<template>
  <card class="card-user">
    <div slot="image">
      <img src="@/assets/img/Portada.jpg"  class="img-fluid" alt="..." />
    </div>
    <div>
      <div class="author">
        <img
          class="avatar border-white"
          :src="rutaApp +'storage/documents/' + persona.Foto"
          alt="..."
        />
        <!-- <img src="@/assets/img/Portada.jpg"  class="avatar border-white" alt="..." /> -->

        <div class="row">
            <h4 class="title">
              {{persona.Persona}}
              <br />
              <a href="#">
                <small class="text-primary"> <b> {{persona.email}} </b></small>
              </a>
            </h4>
            <p class="description text-center">
              <b class="text-warning">  {{persona.ReparticionDireccion}}</b>
              <br />
              <b>
              {{persona.AliasCargo}} </b> <br />
              <!-- I wanna bag it up" -->
            
            </p>
            <p v-if="persona.UnidadAcademica" class="text-center mr-3 text-primary">{{persona.UnidadAcademica}}</p>
          </div>


        
      </div>
      
    </div>
    <hr />


    
    <!-- <div class="text-center">
      <div class="row">
        <div
          v-for="(info, index) in details"
          :key="index"
          :class="getClasses(index)"
        >
          <h5>
            {{ info.title }}
            <br />
            <small>{{ info.subTitle }}</small>
          </h5>
        </div>
      </div>
    </div> -->
  </card>
</template>
<script>

import MainService from "@/services/MainService.js";

export default {
  metaInfo: {
    // Configura los encabezados de respuesta para evitar la caché
    httpEquiv: {
      'Cache-Control': 'no-store',
      Expires: 'Thu, 01 Jan 1970 00:00:00 GMT',
      Pragma: 'no-cache'
    }
  },
  
  name: "PersonaPage",
  data() {
    return {
      ss: new MainService(),
      rutaApp:process.env.VUE_APP_RRHH_SERVICE,

      auth:{},
      sistemasper:[],
      persona:{},
      details: [
        {
          title: "12",
          subTitle: "Files",
        },
        {
          title: "2GB",
          subTitle: "Used",
        },
        {
          title: "24,6$",
          subTitle: "Spent",
        },
      ],

     
    };
  },
  methods: {
    getClasses(index) {
      var remainder = index % 3;
      if (remainder === 0) {
        return "col-lg-3 offset-lg-1";
      } else if (remainder === 2) {
        return "col-lg-4";
      } else {
        return "col-lg-3";
      }
    },

    showPersona() {
      console.log("show");
            
            this.ss.showPersona(this.auth.id).then(
                (result) => {
                    let response = result.data;
                    this.persona = response.data;
                    console.log(this.persona);

                    // this.$refs['view-usuario'].show();
                    // this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
    },

    getSistemasPersona() {
      console.log("list SIS");
      //console.log(this.auth);

        this.ss.listSistemasPersona(this.auth.id).then(
            (result) => {
                let response = result.data;
                this.sistemasper = response.data;
                console.log(this.sistemasper);
            }
        ).catch(error => {
            console.log(error);
            this.isLoading=false;
        });
    },

    print(){
      console.log("hola");
    }
  },

   mounted() {
        this.auth = JSON.parse(localStorage.getItem('usuario'));
        console.log("persona autenticada card",this.auth);
        if (!this.auth) {
            this.$router.push('/Login');
        } else {
            
            this.showPersona();
            this.getSistemasPersona();
            // this.print();
            
        }
    }
};
</script>
<style></style>
